import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { MasterService } from "src/app/Shared/app.Masters.Service";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
import { LmsService } from "../services/lms.service";
declare var $: any;

@Component({
  selector: "app-enachcamspay-process",
  templateUrl: "./enachcamspay-process.component.html",
  styleUrls: ["./enachcamspay-process.component.scss"],
})
export class EnachcamspayProcessComponent implements OnInit {
  showSpinner: boolean = false;
  processSelected: any;
  reponseSelected: any;
  Status: any = "Aweted";
  tab: any = "pendingGenerated";
  dataSourceEnachCamsPay: any;
  dataSourceEnachCamsPayProcess: any;
  LoanAcNo: any;
  LoanDateFrom: any;
  LoanDateTo: any;
  FileCheckingList: any;
  ChequeId: MatTableDataSource<unknown>;
  EMIFromDB: any;
  NoChqs: any;
  Loan_Id: any;
  LastEMI: any;
  StatusDate: any = new Date();
  status: any;
  applicationDetail: any;
  displayedColumnsEnachCamsPay: string[] = [];
  displayedColumnsEnachCamsPayProcess = [
  'LoanId',
  'LoanAcNo',
  'Application_No',
  'Customer_Name',
  'Response',
  'Created_By',
  'Created_On'
];


  EMIFrom: any = 0;
  EMITo: any = 0;
  Id: any;
  currentUser: any;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  // @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('paginatorRef') paginatorRef!: MatPaginator;
@ViewChild('paginatorRef1') paginatorRef1!: MatPaginator;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };


  constructor(
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
    private _MasterService: MasterService,
    private lmsService: LmsService
    
  ) {}

  ngOnInit(): void {
    this.LoanDateFrom = new Date();
    this.LoanDateTo = new Date();
    this.dataSharingService.HeaderTitle.next("E-NACH CAMS Pay");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.displayedColumnsEnachCamsPay = [
      "Id",
      "LoanAcNo",
      "Application_No",
      "CustomerName",
      "Loan_Date",
      "PresentBankInCompanyName",
      "PresentBankInCompany",
      "Status",
      "Identifier",
      "checkButton",
      "Action",
    ];
  }
  changeTab(tab: any) {
    if (tab !== this.tab) {
      this.tab = tab;
      this.processSelected = undefined;
      this.reponseSelected = undefined;
      $(".filterInput").val("");
  
      if (tab === "pendingGenerated") {
        // this.GetQuickLoanDashboardCount();
      } else if (tab === "process") {
        this.OnGet_CAMSPay_Detail_By_Status("Pending");
        // this.Quick_Loan_Get_Manager_Dashboard_ByTeam();
      } else if (tab === "failure") {
        this.OnGet_CAMSPay_Detail_By_Status("Failed");
        // this.Quick_Loan_GetManagerDashboardByProcess();
      }
    }
  }
  OnGet_CAMSPay_Detail_By_Status(status: string) {
    this.showSpinner = true;
    this.lmsService.Get_CAMSPay_Detail_By_Status({
      Status: status,
    }).subscribe((res: any) => {
      this.showSpinner = false;
      this.dataSourceEnachCamsPayProcess = new MatTableDataSource(res);
      this.dataSourceEnachCamsPayProcess.sort = this.sort;
      this.dataSourceEnachCamsPayProcess.paginator = this.paginatorRef1;
    });

  }
   onSearchEnachCamsPay() {
      // console.log("Search Button clicked ");
  
      this.showSpinner = true;
      this.dataSourceEnachCamsPay = null;
  
      this.lmsService
        .LMS_Get_Camspay_NachStatus({
          fromDate: this.LoanDateFrom,
          toDate: this.LoanDateTo,
          LoanAcNo: this.LoanAcNo,
          status: this.Status,
        })
        .subscribe((res: any) => {
          console.log("res : ", res);
          if (res.length > 0) {
            this.FileCheckingList = JSON.parse(JSON.stringify(res));
  
            this.ChequeId = res[0].chqId;
            console.log("CehqueID", this.ChequeId);
  
            this.dataSourceEnachCamsPay = new MatTableDataSource(
              this.FileCheckingList
            );
            this.dataSourceEnachCamsPay.sort = this.sort;
            this.dataSourceEnachCamsPay.paginator = this.paginatorRef;
            this.showSpinner = false;
          } else {
            this.dataSourceEnachCamsPay = null;
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: "No data found",
              ...this.configSuccess,
            });
            this.showSpinner = false;
          }
        });
    }
    changeDate() {
      this.EMIFrom = 0;
      this.EMITo = 0;
      this.lmsService
        .LMS_GET_NACH_EMI_DETAI({
          StatusDate: this.StatusDate,
          Loan_Id: this.Loan_Id,
        })
        .subscribe((res: any) => {
          if (res.length > 0) {
            if (res[0].CODE == 0) {
              // console.log(res);
              this.EMIFrom = res[0].EMI;
              this.EMITo = res[res.length - 1].EMI;
              this.LastEMI = res[res.length - 1].EMI;
            } else {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: res[0].MSG,
                ...this.configSuccess,
              });
              this.EMIFrom = 0;
              this.EMITo = 0;
            }
          }
        });
    }
    goToDetail(row) {
      this.Loan_Id = row.Loan_Id;
      this.changeDate();
  
      this.status = row.status;
      this.Id = row.Id;
      this.lmsService
        .Lms_Get_Nach_Au_Detail({
          LoanAcNo: row.LoanAcNo,
          Id: row.chqId,
          SearchStatus: row.Status,
        })
        .subscribe((res: any) => {
          // console.log(res);
          this.FileCheckingList = JSON.parse(JSON.stringify(res));
          console.log("Data for Get Nach Info", this.FileCheckingList);
          if (res.length > 0) {
            this.applicationDetail = res[0];
            $("#addAUEnachInfo").modal("show");
            $("#addAUEnachInfo").css("z-index", "1050");
          }
          // this.StatusDB = res[0].status;
          // this.Loan_Id = res[0].Loan_Id;
          // this.status = res[0].status;
          // this.Int_Id = res[0].Int_Id;
          // this.chqId = data.chqId;
          // this.FailCount = res[0].FailCount;
          // this.NachAmount = res[0].NachAmount;
          // this.NachCode = res[0].NachCode;
          // this.EMIFrom = res[0].EMIFrom;
          // this.EMITo = res[0].EMITo;
          // this.CustomerId = res[0].CustomerId;
          // this.PdcType = res[0].PdcType;
          // this.ChqFrom = res[0].ChFrom;
          // this.ChqTo = res[0].ChTo;
          // this.NoChqs = res[0].NoChqs;
          // this.LastEMI = res[0].NoOfEMI;
          // this.PresentBankInCompany =
          //   res[0].PresentBankInCompany == null
          //     ? ""
          //     : res[0].PresentBankInCompany;
          // this.process_period = res[0].process_period;
          // this.PresentOnCompanyBank = new Date(
          //   moment(res[0].PresentOnCompanyBank).format("MM/DD/YYYY")
          // );
          // this.StatusDate = new Date(
          //   moment(res[0].StatusDate).format("MM/DD/YYYY")
          // );
          // this.Reason = res[0].Reason;
          // if (res[0].PresentOnCompanyBank == null)
          //   this.PresentOnCompanyBank = new Date();
          // if (res[0].StatusDate == null || res[0].StatusDate == "01 Jan 1900")
          //   this.StatusDate = new Date();
          // if (this.NachAmount == 0) this.NachAmount = "";
        });
    }
    OnClose() {
      $("#addEnachCamsPay").modal("hide");
    }
    onSaveAUEnachInfo() {
      if (this.EMIFrom == 0 || this.EMITo == 0) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "EMI From or EMI To not equal to 0!!",
          ...this.configSuccess,
        });
      } else {
        this.lmsService
          .LMS_Save_AU_ENachInfo({
            EMIFrom: this.EMIFrom,
            EMITo: this.EMITo,
            Loan_Id: this.Loan_Id,
            LoginUserId: this.currentUser.userId,
            chqId: this.ChequeId,
            Id: this.Id,
            StatusDate: this.StatusDate,
          })
          .subscribe((res: any) => {
            if (res[0].CODE == 0) {
              console.log("Data Saved");
              this.OnClose();
              this.onSearchEnachCamsPay();
            } else {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: res[0].MSG,
                ...this.configSuccess,
              });
            }
          });
      }
    }
    onExport(exporter: any, name) {
      exporter.exportTable("xls", {
        fileName: `${name}`,
        sheet: "ENACH-CAMS-Pay",
      });
    }
}
